
class Video {
  constructor(element) {
    this.element = element;
    this.lazyLoaded = 0;
    this.init();
  }

  getElement(){
    return this.element;
  }

  getContainer() {
    return document.querySelector('.js-videoContainer');
  }

  getPlay(){
    return document.querySelector('.js-play');
  }

  getVideo() {
    return document.querySelector('.js-iframe');
  }

  setYoutubeAPI() {
    let tag = document.createElement('script');
    let videoEl = this.getVideo();
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    var player;
    setTimeout(() => {
      player = new YT.Player('player', {
        playerVars: {
          'playsinline': 1
        }
      });
    },200)
  }
  
  showContainer() {
    let containerEl = this.getContainer();
    containerEl.classList.add('active');
  }

  closeContainer() {
    let containerEl = this.getContainer();
    containerEl.classList.remove('active');
  }

  closeOverlay() {
    let overlayEl = this.getContainer();
    overlayEl.addEventListener('click', () => {
      this.closeContainer();
    })
  }

  loadVideo() {
    let videoEl = this.getVideo();

    if(this.lazyLoaded === 0){
      videoEl.src = videoEl.dataset.src;
      this.setYoutubeAPI();
      this.lazyLoaded = 1;
    }
  }

  setPlay(){
    let playEl = this.getPlay();
    playEl.addEventListener('click', () => {
      this.showContainer();
      this.loadVideo();
    })
  }

  setEventHandlers() {
    window.addEventListener('load', (event) => {
      this.setPlay();
      this.closeOverlay();
    });
  }

  init() {
    this.setEventHandlers();
  }
}


const VideoInit = {
  init() {
    const $el = document.querySelector(".js-video");
    if ($el) {
        new Video($el);
    }
  },
};


export default VideoInit;

